import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Miraroadtopunecab() {



const cardData = {
  keyword: " Mira Road to Pune Cab",

headingDescription: "Velocity Cab provides reliable and comfortable Mira Road to Pune cab services, ensuring a smooth and hassle-free journey for business trips, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mira Road to Pune convenient and stress-free. The journey covers approximately 150–160 km via the Mumbai–Pune Expressway, typically taking 3–4 hours depending on traffic conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mira Road to Pune cab travel.",

topPlaces: [
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It is known for its spiritual ambiance and historical significance in Pune."
  },
    {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered spiritual landmarks dedicated to Lord Ganesha. Devotees and travelers can experience divine blessings, beautifully decorated idols, and a vibrant atmosphere, especially during major festivals like Ganesh Chaturthi."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Visitors can explore its grand gateways, ruins, and enjoy the evening light and sound show that narrates Pune’s royal history."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a serene Japanese-style garden featuring lush greenery, water streams, and beautifully designed walking paths. It is an ideal place for relaxation, photography, and peaceful nature walks."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a historically significant monument linked to India’s freedom movement. It features elegant architecture, spacious gardens, and a museum dedicated to Mahatma Gandhi and important historical events."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a popular heritage site in Pune offering panoramic city views from its hilltop temples. Visitors can climb the steps to explore ancient shrines and enjoy a peaceful, scenic environment."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a well-known garden in Pune featuring lush green spaces and the famous Siddhivinayak Temple. It is a favorite spot for families, walkers, and visitors seeking relaxation in the city."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a riverside park offering greenery, walking tracks, and boating facilities. It is a peaceful location for evening strolls and leisure activities in Pune."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases a rich collection of Indian artifacts, including sculptures, musical instruments, and cultural items that reflect India’s heritage and traditions."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a popular shopping and entertainment hub featuring international brands, restaurants, cinemas, and entertainment zones, making it ideal for leisure and shopping experiences."
  },

],



services: [
{
name: "Pune to Mira Road Cab",
description: "Pune to Mira Road cab service offers reliable and comfortable travel for passengers looking for smooth intercity transportation. This service is ideal for both personal and business travel with well-maintained vehicles and experienced drivers. Customers can choose from sedan, SUV, and premium cab options based on their needs. Timely pickup and drop ensure a hassle-free journey. Transparent pricing helps in easy budget planning without hidden charges. Flexible booking options make travel convenient. It is a trusted option for Pune to Mira Road travel."
},
{
name: "Bhayandar to Pune Cab",
description: "Bhayandar to Pune cab service provides safe and affordable travel solutions for passengers traveling between these two cities. This service ensures comfortable rides with clean and well-maintained vehicles. Professional drivers ensure timely pickups and smooth highway journeys. It is ideal for one way, round trip, and outstation travel needs. Transparent pricing with no hidden costs makes it customer-friendly. Flexible booking options allow easy scheduling. It is one of the most preferred cab services for Bhayandar to Pune travel."
},
{
name: "Bhayandar to Pune Cab Service",
description: "Bhayandar to Pune cab service offers reliable transportation for daily travel, business trips, and family journeys. This service includes multiple vehicle options such as sedan, SUV, and Innova for comfortable travel. Drivers are experienced and ensure safe journeys across highways. Customers benefit from transparent billing and affordable fares. Flexible pickup and drop options enhance convenience. It is suitable for both one way and round trip travel. It ensures a smooth and stress-free travel experience."
},
{
name: "Bhayandar to Pune Taxi Service",
description: "Bhayandar to Pune taxi service provides economical and convenient travel options for passengers seeking dependable transportation. Vehicles are clean and well-maintained ensuring comfort during long-distance travel. Professional drivers ensure timely service and safe driving. Ideal for airport transfers, business travel, and personal trips. Transparent pricing ensures no hidden charges. Easy booking options make it convenient for users. It is a trusted taxi service for Bhayandar to Pune routes."
},
{
name: "Bhayandar to Pune One Way Cab",
description: "Bhayandar to Pune one way cab service is perfect for travelers looking for cost-effective single-side travel without return charges. This service helps reduce travel costs significantly compared to round trips. Customers can choose from a range of vehicles including sedan and SUV options. Professional drivers ensure safe and timely travel. Transparent pricing ensures no hidden fees. Easy booking with instant confirmation adds convenience. It is the best option for one way travel."
},
{
name: "Bhayandar to Pune Taxi Fare",
description: "Bhayandar to Pune taxi fare is designed to be affordable and transparent for customers planning their travel. Pricing depends on vehicle type, travel distance, and trip type such as one way or round trip. Customers receive clear fare details before booking. No hidden charges ensure trust and reliability. Competitive pricing makes it budget-friendly. Flexible options allow customers to choose according to their budget. It is ideal for cost-conscious travelers."
},
{
name: "Bhayandar to Pune Cab Booking",
description: "Bhayandar to Pune cab booking provides a simple and quick way to reserve your cab for comfortable travel. Customers can book online or via phone with instant confirmation. Multiple vehicle options are available for different travel needs. Professional drivers ensure safe and timely pickups. Transparent pricing ensures clarity in billing. Flexible scheduling allows customers to plan trips easily. It offers a hassle-free booking experience."
},
{
name: "Cab from Bhayandar to Pune",
description: "Cab from Bhayandar to Pune offers comfortable and reliable transportation for intercity travel. This service is suitable for family trips, business travel, and personal journeys. Vehicles are well-maintained and equipped for long-distance travel. Professional drivers ensure smooth and safe rides. Flexible booking options make travel planning easy. Transparent pricing ensures no hidden charges. It is a convenient option for traveling between Bhayandar and Pune."
},
{
name: "Bhayandar to Pune Car Rental",
description: "Bhayandar to Pune car rental service provides flexible travel options for customers who prefer private and comfortable journeys. Customers can choose from a wide range of vehicles including sedan, SUV, and premium cars. Well-maintained vehicles ensure a smooth ride. Professional drivers enhance safety and convenience. Transparent pricing ensures clear billing. Flexible rental plans suit different travel needs. It is ideal for both short and long-distance trips."
},
{
name: "Bhayandar to Pune Taxi Booking Online",
description: "Bhayandar to Pune taxi booking online offers a convenient way to book your cab from anywhere with just a few clicks. Customers can compare vehicle options and fares easily. Instant booking confirmation ensures quick travel planning. Professional drivers ensure safe and timely service. Transparent pricing avoids hidden charges. Flexible booking options enhance convenience. It is the best way to book your cab online."
},
{
name: "Cheap Cab Bhayandar to Pune",
description: "Cheap cab Bhayandar to Pune provides budget-friendly travel options for passengers looking for economical rides. This service ensures comfortable travel at affordable rates. Vehicles are clean and well-maintained for safe journeys. Professional drivers ensure smooth travel experience. Transparent pricing ensures no hidden costs. Flexible booking options add convenience. It is ideal for budget-conscious travelers."
},
{
name: "Bhayandar to Pune Outstation Cab",
description: "Bhayandar to Pune outstation cab service offers reliable transportation for long-distance travel with comfort and safety. This service is suitable for family trips, corporate travel, and weekend getaways. Vehicles are maintained for highway journeys ensuring smooth rides. Professional drivers ensure safe and timely travel. Flexible options include one way and round trips. Transparent pricing ensures clear billing. It is a trusted choice for outstation travel."
},
{
name: "Bhayandar to Pune AC Taxi Service",
description: "Bhayandar to Pune AC taxi service provides comfortable and air-conditioned travel for passengers seeking a premium experience. This service ensures a pleasant journey even during long-distance travel. Vehicles are clean, well-maintained, and equipped with AC. Professional drivers ensure safe and smooth rides. Transparent pricing ensures no hidden charges. Flexible booking options make it convenient. It is ideal for comfortable travel."
},
{
name: "Bhayandar to Pune Innova Cab",
description: "Bhayandar to Pune Innova cab service offers spacious and comfortable travel for families and groups. This service is ideal for long-distance journeys with extra luggage space and seating comfort. Vehicles are well-maintained and equipped for highway travel. Professional drivers ensure safe and smooth rides. Transparent pricing ensures clarity in fares. Flexible booking options make it convenient. It is a preferred choice for group travel."
},
{
name: "Bhayandar to Pune SUV Taxi",
description: "Bhayandar to Pune SUV taxi service provides powerful and comfortable vehicles suitable for long-distance travel. This service is ideal for group travel, family trips, and corporate journeys. Vehicles offer ample space and smooth performance on highways. Professional drivers ensure safe and timely service. Transparent pricing ensures no hidden costs. Flexible booking options enhance convenience. It is a great option for comfortable SUV travel."
},
{
name: "Bhayandar to Pune Cab Price",
description: "Bhayandar to Pune cab price is structured to offer affordable and transparent fares for all types of travelers. Pricing varies based on vehicle type, trip type, and travel requirements. Customers receive clear fare details before booking. No hidden charges ensure trust and reliability. Competitive pricing makes it budget-friendly. Flexible options allow customers to choose according to their needs. It is ideal for planning travel expenses easily."
}
],

tableData: [
["Bhayandar to Pune Cab","Bhayandar to Pune Taxi Service"],
["Bhayandar to Pune One Way Cab","Bhayandar to Pune Cab Booking"],
["Cheap Cab Bhayandar to Pune","Bhayandar to Pune Outstation Cab"],
["Bhayandar to Pune Innova Cab","Bhayandar to Pune SUV Taxi"],
["Bhayandar to Pune Cab Price","Pune to Mira Road Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Intercity Travel",
    WhyChoosedescription: "Velocity Cabs offers reliable Mira Road to Pune cab service for a smooth and comfortable journey via the Mumbai Pune Expressway, ideal for business trips, family travel, and weekend getaways."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mira Road to Pune routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mira Road to Pune cab bookings. Customers receive full fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mira Road to Pune cab service operates 24/7. Whether you need early morning pickup or late-night travel, we ensure reliable cab availability anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and same-day return trips between Mira Road and Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mira Road to Pune cab bookings due to punctual drivers, clean vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mira Road to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mira Road to Pune for one-way and round-trip travel." },
  { question: "How far is Pune from Mira Road?", answer: "The distance between Mira Road and Pune is approximately 150 to 170 km and travel time is around 3.5 to 4.5 hours depending on traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mira Road to Pune cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Mira Road to Pune." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mira Road to Pune cabs online or through phone booking." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from homes, societies, and offices across Mira Road." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and peak travel hours." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep More",
    feedback:
      "The Mira Road to Pune cab journey was very smooth and well-managed. The cab arrived on time, the ride was comfortable, and the travel experience felt completely hassle-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "Traveling from Mira Road to Pune was a pleasant experience. The vehicle was clean, the drive was steady, and everything was handled in a professional and reliable way.",
    rating: 5
  }
];




















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const miraRoadPuneCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mira Road to Pune Cab | Velocity Cabs",
  "description": "Book a private cab from Mira Road/Bhayandar to Pune for comfortable outstation travel. AC, Sedan, Innova, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mira Road, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mira Road to Pune Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mira Road to Pune",
        "description": "Private cab from Mira Road/Bhayandar to Pune for one-way travel with AC, SUV, Sedan, or Innova options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mira Road to Pune Cab",
        "description": "Comfortable round-trip cab service from Mira Road/Bhayandar to Pune with private AC, SUV, Sedan, or Innova options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};





  return (
    <div>
      
<Helmet>
  <title>Mira Road to Pune Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mira Road/Bhayandar to Pune for comfortable outstation travel. AC, Sedan, Innova, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(miraRoadPuneCabJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/113.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Miraroadtopunecab;